export { default } from './getBreakpointFallback'
